<template>
    <div class="page-box intelligentService">
      <Header/>
      <div class="mg-bottom-70 bg-color-EAF1FA">
        <TopBanner :top-banner-img="BannerImg" title2="智能客服" :titleStyle="{fontSize: '35px'}" title-row1="覆盖在线、呼叫、视频等全渠道业务场景的客户服务" title-row2="以AI驱动，让智能服务创造" blue-text="业务价值" :title-tips-list="titleTipsList" :contentStype="{paddingTop: '180px'}">
        </TopBanner>
      </div>
      <!-- 在线客服 -->
      <div class="goods-manage pd-bottom-100">
        <ModuleTitle data-aos="fade-up" title="在线客服" :moduleTipsList="[{name: '全面覆盖客户触点，统一接待，高效咨询'}]" />
        <ModuleCenter>
          <div class="flex-box" data-aos="fade-up">
            <div class="goods-manage-left goods-manage-item">
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">覆盖主流沟通渠道</span>
                  <div>支持Web、APP、微信、微博、抖音、支付宝小程序、百度小程序、消息接口等方式接入</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">会话智能管理</span>
                  <div>支持会话智能分配、管理，实现访客分流，支持VIP专属服务等，确保最佳体验</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">支持主动营销</span>
                  <div>根据不同客户属性、画像、标签匹配精准营销策略，提升商品转化</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">支持业务系统轻量集成</span>
                  <div>通过集成或iframe嵌入，让企业CRM、订单、物流等系统无缝连接</div>
                </div>
              </div>
            </div>
            <div class="goods-manage-middle">
              <img class="goods-manage-mid-img" src="@/assets/product/digitalSystem/intelligentService-1.png" alt="" />
            </div>
          </div>
        </ModuleCenter>
      </div>
      <!-- 在线机器人 -->
      <div class="goods-manage pd-top-70 pd-bottom-100" style="background-color: #F4F5FB">
        <ModuleTitle data-aos="fade-up" title="在线机器人" :moduleTipsList="[{name: '真正懂用户的文本机器人，独立解决80%常见问题'}]" />
        <ModuleCenter>
          <div class="flex-box" data-aos="fade-up">
            <div class="goods-manage-middle">
              <img class="goods-manage-mid-img" style="width: 629px;height: 464px;" src="@/assets/product/digitalSystem/intelligentService-2.png" alt="" />
            </div>
            <div class="goods-manage-right goods-manage-item">
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content width-400">
                  <span class="item-ilne-title">7x24h 智能问答</span>
                  <div>满足零售电商、社交电商、企业服务等多业务场景问答需求</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content width-400">
                  <span class="item-ilne-title">复杂业务办理</span>
                  <div>实现任务式问答，通过多轮对话引导访客根据业务流程进行业务查询及办理</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content width-400">
                  <span class="item-ilne-title">知识库冷启动</span>
                  <div>丰富的语料数据积累和10+行业知识云，助力企业快速搭建知识库，降低交付周期</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content width-400">
                  <span class="item-ilne-title">专业的机器人训练服务</span>
                  <div>提供机器人诊断、机器人调优、机器人培训等服务，提升机器人匹配率和解决率</div>
                </div>
              </div>
            </div>
          </div>
        </ModuleCenter>
      </div>
      <!-- 云呼叫中心 -->
      <div class="goods-manage pd-bottom-100 pd-top-70">
        <ModuleTitle data-aos="fade-up" title="云呼叫中心" :moduleTipsList="[{name: '随时响应电话热线咨询，1小时快速部署，安全稳定'}]" />
        <ModuleCenter>
          <div class="flex-box" data-aos="fade-up">
            <div class="goods-manage-left goods-manage-item">
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">满足多种外呼场景</span>
                  <div>电话销售、客服服务、催收催缴、预约提醒、调查问卷、客户关怀各种场景都支持</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">模拟语音</span>
                  <div>多种任务类型的语音库，包含甜美、成熟、知性等各种特点，满足企业不同业务场景下的呼叫服务</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">智能外呼任务</span>
                  <div>支持人工一键点击外呼、预测式外呼、预览式外呼、AXB和双向外呼等多种外呼方式，支持语音机器人外呼，适配多个场景，满足企业不同外呼需求</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">会话数据实时管理</span>
                  <div>支持从线索的分配、领取、跟进到转化，销售全流程监管通话全程记录，录音可查可听。销售漏斗掌握客户跟进情况，及时优化销售流程</div>
                </div>
              </div>
            </div>
            <div class="goods-manage-middle">
              <img class="goods-manage-mid-img" style="width: 646px;height: 513px;" src="@/assets/product/digitalSystem/intelligentService-3.png" alt="" />
            </div>
          </div>
        </ModuleCenter>
      </div>
      <!-- 工单系统 -->
      <div class="goods-manage pd-top-70 pd-bottom-100" style="background-color: #F4F5FB">
        <ModuleTitle data-aos="fade-up" title="工单系统" :moduleTipsList="[{name: '支持多渠道创建工单，灵活高效流转，增强跨部门协作'}]" />
        <ModuleCenter>
          <div class="flex-box" data-aos="fade-up">
            <div class="goods-manage-middle">
              <img class="goods-manage-mid-img" style="width: 680px;height: 388px;" src="@/assets/product/digitalSystem/intelligentService-4.png" alt="" />
            </div>
            <div class="goods-manage-right goods-manage-item">
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content width-400">
                  <span class="item-ilne-title">支持多渠道、多角色、多场景，跨平台创建工单</span>
                  <div>支持多种工单创建方式，访客创建、客服创建、邮件创建、跨平台创建、接口创建等</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content width-400">
                  <span class="item-ilne-title">支持高效率处理及流转工单</span>
                  <div>工单关联、预设工单回复、复制工单等工具提升坐席复杂问题的处理效率</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content width-400">
                  <span class="item-ilne-title">支持满意度评价，不断提升服务质量</span>
                  <div>多渠道邀请坐席及访客评价满意度，考核坐席绩效的同时不断提升服务质量</div>
                </div>
              </div>
            </div>
          </div>
        </ModuleCenter>
      </div>
      <!-- 人工智能 -->
      <div class="goods-manage pd-bottom-100 pd-top-70">
        <ModuleTitle data-aos="fade-up" title="人工智能" :moduleTipsList="[{name: 'AIGC帮你生成促销文案、剪辑视频，同时投放到小红书、微博等平台'}]" />
        <ModuleCenter>
          <div class="flex-box" data-aos="fade-up">
            <div class="goods-manage-left goods-manage-item">
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">脚本文案</span>
                  <div>输入关键词、场景等信息，一键生成多行业爆款脚本文案不愁没灵感</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">智能剪辑</span>
                  <div>仅需少量素材片段，快速批量混剪大量视频，可自定义风格、场景，助力企业宣传不重复</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">多账号营销批量发布</span>
                  <div>多平台一键发布，多账号批量管理，一键批量分发短视频至小红书、微博、抖音、快手等平台，获取短视频更多曝光实现获客营销新增长</div>
                </div>
              </div>
            </div>
            <div class="goods-manage-middle">
              <img class="goods-manage-mid-img" style="width: 640px;height: 350px;" src="@/assets/product/digitalSystem/intelligentService-5.png" alt="" />
            </div>
          </div>
        </ModuleCenter>
      </div>
      <Footer/>
    </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import TopBanner from './components/topBanner.vue'
import Banner from '@/assets/product/digitalSystem/banner-7.jpg'
import ModuleTitle from './components/moduleTitle.vue'
import ModuleCenter from './components/moduleCenter.vue'
import CardItem from './components/cardItem.vue'
import IMBanner1 from '@/assets/product/digitalSystem/integration-module-banner-1.png'
import Cancel from '@/assets/product/digitalSystem/cancel-icon.png'
import ModuleBgBlue from './components/moduleBgBlue.vue'
import OneStopBanner from '@/assets/product/digitalSystem/One-Stop-banner.png'
import SimpleCance from '@/assets/home/check.svg'
import imgText1 from '@/assets/product/digitalSystem/img-text-1.png'
import BgBlue from '@/assets/product/bg-blue.png'
import metaInfo from "@/common/util/metaInfo"
export default {
  metaInfo: metaInfo.intelligentService,
  components: {
    Header,
    Footer,
    TopBanner,
    ModuleTitle,
    ModuleCenter,
    CardItem,
    IMBanner1,
    ModuleBgBlue
  },
   data() {
      return {
        CancelImg: Cancel,
        BgBlue: BgBlue,
        imgText1: imgText1,
        BannerImg: Banner,
        titleTipsList: [
          {
            name: '全场景覆盖：在线、呼叫、视频等多元沟通渠道'
          },
          {
            name: 'AI技术核心：以人工智能为动力，革新客户服务体验'
          },
          {
            name: '价值创造：提升服务效率与质量，推动业务增长'
          }
        ],
        painList: [
          {
            icon: require("@/assets/product/svgIcon/pain-spot-13.svg"),
            name: '无法寻源',
            imgShow: false,
            descList: [
              '订单无法有效寻源，人工派发工作量大，容易出错',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-10.svg"),
            name: '售后处理不及时',
            imgShow: false,
            descList: [
              '用户退货退款时效长，无法满足线上平台要求，容易被平台方触发',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-4.svg"),
            name: '灵活性不足',
            imgShow: false,
            descList: [
              '做数字化转型，针对线上交易多变和时效性，流程繁琐笨重',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-8.svg"),
            name: '多渠道支持',
            imgShow: false,
            descList: [
              '面对多平台销售，需要大量重复的商品维护、订单补录等重复性线下工作',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-2.svg"),
            name: '库存更新不及时',
            imgShow: false,
            descList: [
              '与上游供货商离线协同，难以做到多渠道一盘货管理',
            ]
          }
        ],
        cardStyle: {
          width: '224px',
          height: '220px',
          padding: '30px 20px 0 20px',
          marginBottom: '0px'
        },
        serviceabilityList: [
          {
            icon: require("@/assets/product/svgIcon/core-advantages-6.svg"),
            name: '全域获客',
            imgShow: false,
            descList: [
              '会员价值模型及有效的触达体系，基于用户旅程构建完整的全域触点连接方案实现海量且长效的用户获取',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/Unicom-7.svg"),
            name: '傻瓜式运营',
            imgShow: false,
            descList: [
              '提供丰富的运营素材（包含图片、视频等），适配各种行业的页面模板，可快速、无门槛的运营',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/core-advantages-5.svg"),
            name: '多模式运营',
            imgShow: false,
            descList: [
              '支持商家入驻+平台自营多种运营模式，入驻服务年费、商品销售佣金等多种盈利方式',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/Unicom-6.svg"),
            name: '定向营销',
            imgShow: false,
            descList: [
              '基于用户个体需求，实行千人千策营销策路，为每个用户提供所需且极致的用户体验',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/Unicom-8.svg"),
            name: '商品上架',
            imgShow: false,
            descList: [
              '灵活的产品参数，全行业产品支持、特别是对于工业配件以及工业品多参数的用户筛选和销售上，灵活设置',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/Unicom-9.svg"),
            name: '全息洞察',
            imgShow: false,
            descList: [
              '设定标签体系，构建用户全渠道画像布局，实现可实时感知的用户需求及用户资产沉淀',
            ]
          }
        ],
        serviceabilityStyle: {
          width: '380px',
          height: '210px',
          padding: '30px 40px 0 40px',
          marginBottom: '30px'
        },
        CarouselList: [{
          url: require('@/assets/product/digitalSystem/carousel-1.png'),
        },{
          url: require('@/assets/product/digitalSystem/carousel-2.png'),
        },{
          url: require('@/assets/product/digitalSystem/carousel-3.png'),
        }],
        painCardStyle: {
          width: '224px',
          height: '210px',
          padding: '30px 20px 0 20px',
          marginBottom: '0px'
        },
      }
   },
   created(){
   },
   computed:{
   },
   methods:{
   },
}
</script>
<style lang="less" scoped>
.page-box {
  background-color: #fff;
}
.bg-color-EAF1FA {
  background-color: #EAF1FA;
}
.flex-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.top-banner-tips{
  font-size: 16px;
  color: #222222;
  line-height: 28px;
  margin-bottom: 24px;
  width: 638px;
}
.mg-bottom-70 {
  margin-bottom: 70px;
}
/* 图文导航 */
.image-text-item {
  display: flex;
}
.image-text-item-left {
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  width: 468px;
  height: 220px;
  text-align: left;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 20px;
  padding: 37px 0 0 30px;
  margin-right: 20px;
}
.title-text {
  font-weight: bold;
  font-size: 22px;
  color: #FFFFFF;
  line-height: 32px;
}
.pd-bottom-90 {
  padding-bottom: 90px;
}
/* 零售商城具备完善的服务能力 */
.barrier-background {
  width: 100%;
  min-width: 1200px;
  background-repeat: no-repeat;
  background-size: 1920px 100%;
  background-position: center;
}
.pd-top-70 {
  padding-top: 70px;
}
/* 会员体系打造 等级成长持续活跃 */
.active-item {
  width: 580px;
  height: 430px;
  background: #FFFFFF;
  border-radius: 10px;
  overflow: hidden;
  padding: 40px 40px 0 40px;
  text-align: left;
  font-size: 14px;
  color: #595859;
  line-height: 22px;
}
.active-item-title {
  font-weight: bold;
  font-size: 22px;
  color: #222222;
  line-height: 22px;
  margin-bottom: 14px;
}
.active-item-img {
  width: 500px;
  height: 280px;
  margin-top: 30px;
}
.border-shadow {
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.08);
}
/* 一键美化，轻松运营！打造专属您的线上商城！ */
.Carousel-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
}
.Carousel-item-title {
  font-size: 24px;
  color: #222222;
  line-height: 46px;
  margin-bottom: 50px;
}
.mg-bottom-50 {
  margin-bottom: 50px;
}
.Carousel-right, .Carousel-img {
  width: 650px;
  height: 550px;
}
.pd-bottom-100 {
  padding-bottom: 100px;
}
.mg-bottom-100{
  margin-bottom: 100px;
}
/* 订单处理快准强，系统稳定有保障 */
.goods-manage-ilne {
  display: flex;
  text-align: left;
  font-size: 14px;
  color: #595859;
  line-height: 22px;
}
.item-ilne-icon {
  width: 20px;
  height: 15px;
  margin-right: 10px;
}
.item-ilne-title {
  display: inline-block;
  font-weight: bold;
  font-size: 22px;
  color: #222222;
  line-height: 22px;
  margin-bottom: 14px;
}
.item-ilne-content {
  width: 430px;
}
.goods-manage-mid-img {
  width: 648px;
  height: 440px;
}
.goods-manage-item {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.width-400 {
  width: 400px;
}
.goods-manage-right {
  padding-top: 7px;
}
</style>
